import { useEffect, useCallback } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useAnalytics() {
  const trackPageView = useCallback((page) => {
    axios.post(`${API}/analytics/pageview`, {
      page,
      referrer: document.referrer,
      user_agent: navigator.userAgent,
    }).catch(() => {});
  }, []);

  return { trackPageView };
}

export function usePageTracking() {
  const { trackPageView } = useAnalytics();

  useEffect(() => {
    trackPageView(window.location.pathname);

    // Track section visibility
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            trackPageView(`/#${entry.target.id}`);
          }
        });
      },
      { threshold: 0.5 }
    );

    const sections = document.querySelectorAll('section[id]');
    sections.forEach((s) => observer.observe(s));

    return () => observer.disconnect();
  }, [trackPageView]);
}

// Google Analytics 4 — Mess-ID ist ein public Identifier (kein Secret).
// Sebastian-Setup 2026-06-10: GA-ID hardcoded mit ENV-Override-Möglichkeit.
const GA_DEFAULT_ID = 'G-J1LVSGZR3H';

// Nur auf Produktions-Domain laden — verhindert Tracking auf localhost/dev/staging.
function _isProductionHost() {
  if (typeof window === 'undefined') return false;
  const h = window.location.hostname;
  return h === 'enbet-consulting.de' || h === 'www.enbet-consulting.de';
}

// Verhindert Doppel-Init wenn beide CookieConsent-Pfade greifen (initial + accept).
let _gaInitialized = false;

export function initGoogleAnalytics() {
  if (_gaInitialized) return;
  const gaId = process.env.REACT_APP_GA_ID || GA_DEFAULT_ID;
  if (!gaId) return;
  if (!_isProductionHost()) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  gtag('js', new Date());
  gtag('config', gaId, { anonymize_ip: true });
  window.gtag = gtag;
  _gaInitialized = true;
}
